import React from 'react'

export const TextBelowTitle:React.FC<{text: string}> = ({text}) => {
  return (
    <div className="text-left text-[#6F6F6F] leading-[18px] font-extralight text-sm pt-[12px]">
      {text}
    </div>
  )
}
